var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinear = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-icon": "info",
  "data-variant": "linear",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 8v5M11.995 16h.009"
})));
export { SvgLinear as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLWljb249ImluZm8iIGRhdGEtdmFyaWFudD0ibGluZWFyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiPgoKPHBhdGggZD0iTTEyIDhWMTMiIHN0cm9rZT0iY3VycmVudENvbG9yIiAvPgo8cGF0aApkPSJNMTEuOTk0NSAxNkgxMi4wMDM1IgpzdHJva2U9ImN1cnJlbnRDb2xvciIKc3Ryb2tlV2lkdGg9IjIiCi8+Cjwvc3ZnPg==";